/* David Pladen — "Our looks" (sections/dp-looks.liquid)
 * Desktop: the arrows and the strip of thumbnails show one look at a time
 * (wraps around); the counter, progress bars and the watch follow.
 * Mobile: the photos swipe sideways; the watch under them follows the photo
 * that is most in view.
 */

if (!customElements.get('dp-looks')) {
  customElements.define(
    'dp-looks',
    class DpLooks extends HTMLElement {
      connectedCallback() {
        this.photos = Array.from(this.querySelectorAll('[data-stl-photo]'));
        this.prods = Array.from(this.querySelectorAll('[data-stl-prod]'));
        this.segs = Array.from(this.querySelectorAll('.stl-seg i'));
        this.thumbs = Array.from(this.querySelectorAll('[data-stl-go]'));
        this.cur = this.querySelector('[data-stl-cur]');
        this.track = this.querySelector('[data-stl-track]');
        this.mobile = window.matchMedia('(max-width: 989px)');
        this.index = 0;

        this.addEventListener('click', (event) => {
          const arrow = event.target.closest('[data-stl-dir]');
          if (arrow) {
            this.show(this.index + parseInt(arrow.dataset.stlDir, 10), { scroll: true });
            return;
          }
          const thumb = event.target.closest('[data-stl-go]');
          if (thumb) this.show(parseInt(thumb.dataset.stlGo, 10), { scroll: true });
        });

        // Mobile: follow the photo that is most in view
        this.track?.addEventListener(
          'scroll',
          () => {
            if (!this.mobile.matches) return;
            window.clearTimeout(this.scrollTimer);
            this.scrollTimer = window.setTimeout(() => {
              const i = this.visibleIndex();
              if (i !== this.index) this.show(i);
            }, 80);
          },
          { passive: true }
        );

        // Theme editor: selecting a look block shows it
        this.onBlockSelect = (event) => {
          const i = this.photos.indexOf(event.target);
          if (i > -1) this.show(i, { scroll: true });
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      show(next, { scroll = false } = {}) {
        const n = this.photos.length;
        if (!n) return;
        this.index = (next + n) % n;
        const i = this.index;
        this.photos.forEach((el, k) => el.classList.toggle('is-on', k === i));
        this.prods.forEach((el, k) => {
          el.hidden = k !== i;
        });
        this.segs.forEach((el, k) => el.classList.toggle('is-on', k === i));
        this.thumbs.forEach((el, k) => {
          el.classList.toggle('is-on', k === i);
          el.setAttribute('aria-current', k === i ? 'true' : 'false');
        });
        if (this.cur) this.cur.textContent = String(i + 1).padStart(2, '0');
        [this.photos[i], this.prods[i]].forEach((el) =>
          el?.querySelectorAll('img[loading="lazy"]').forEach((img) => {
            img.loading = 'eager';
          })
        );
        if (scroll && this.mobile.matches && this.track) {
          this.track.scrollTo({ left: this.photos[i].offsetLeft - this.photos[0].offsetLeft, behavior: 'auto' });
        }
      }

      visibleIndex() {
        if (this.photos.length < 2) return 0;
        const step = this.photos[1].offsetLeft - this.photos[0].offsetLeft || 1;
        return Math.min(this.photos.length - 1, Math.max(0, Math.round(this.track.scrollLeft / step)));
      }
    }
  );
}
